import { BRAND_NAME } from '@/constants/brand';

const SEP = ' · ';

// Deepest match first; each title once, then the brand.
export const composeRouteTitle = (
  titles: readonly (string | undefined)[],
  resolve: (title: string) => string,
  dynamicLabel?: string | null,
): string => {
  const segments: string[] = [];
  if (dynamicLabel) segments.push(dynamicLabel);
  for (let i = titles.length - 1; i >= 0; i -= 1) {
    const title = titles[i];
    const text = title && resolve(title);
    if (text && !segments.includes(text)) segments.push(text);
  }
  return segments.length
    ? `${segments.join(SEP)}${SEP}${BRAND_NAME}`
    : BRAND_NAME;
};
